"use client"

import { SearchIcon, X } from "lucide-react"

import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput
} from "@/components/ui/input-group"
import { cn } from "@/lib/utils"
import { useSidebarStore } from "@/stores/sidebar"
import { useSidebarSearchStore } from "@/stores/sidebar-search"

import { texts } from "./localization/texts"
import {
  sidebarIconClassName,
  sidebarItemClassName,
  sidebarItemCollapsedClassName
} from "./SidebarRow"

type SidebarSearchProps = {
  isCollapsed: boolean
}

export function SidebarSearch({ isCollapsed }: SidebarSearchProps) {
  const expand = useSidebarStore((state) => state.expand)
  const query = useSidebarSearchStore((state) => state.query)
  const setQuery = useSidebarSearchStore((state) => state.setQuery)

  if (isCollapsed) {
    return (
      <button
        type="button"
        onClick={expand}
        aria-label={texts.searchAria}
        title={texts.searchAria}
        className={cn(
          sidebarItemClassName,
          sidebarItemCollapsedClassName,
          "hover:text-white/80"
        )}
      >
        <SearchIcon
          className={cn(sidebarIconClassName, "stroke-current")}
          width={24}
          height={24}
          aria-hidden
        />
      </button>
    )
  }

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
      }}
      role="search"
      className="flex flex-col gap-3"
    >
      <InputGroup variant="surface" className="h-10 rounded-xl">
        <InputGroupAddon align="inline-start" className="text-white/40">
          <SearchIcon className="size-4 shrink-0" aria-hidden />
        </InputGroupAddon>
        <InputGroupInput
          type="text"
          name="sidebar-search"
          value={query}
          onChange={(event) => {
            setQuery(event.target.value)
          }}
          aria-label={texts.searchAria}
          placeholder={texts.searchPlaceholder}
          autoComplete="off"
          className="font-normal"
        />
        {query.length > 0 ? (
          <InputGroupAddon align="inline-end">
            <button
              type="button"
              onClick={() => {
                setQuery("")
              }}
              aria-label={texts.searchClear}
              className="text-white/50"
            >
              <X className="size-5" aria-hidden />
            </button>
          </InputGroupAddon>
        ) : null}
      </InputGroup>
    </form>
  )
}
